export const EventBus = {
  emit: (event: string, body?: CustomEventInit): void => {
    const customEvent = new CustomEvent(event, body);

    window.dispatchEvent(customEvent);
  },
  on: (event: string, listener: EventListener) => {
    window.addEventListener(event, listener);
  },
  off: (event: string, listener: EventListener) => {
    window.removeEventListener(event, listener);
  },
};

interface EventMap {
  'ni-v2/route-changed': { route: string };
  'ni-v2/cart-updated': undefined;
  'ni-v2/hydrated': undefined;
  'ni/hydrated': undefined;
  'micro-server/client-ready': { name: string };
  'micro-server/hydrated': { name: string };
}

export const TypedEventBus = {
  emit<K extends keyof EventMap>(event: K, body?: EventMap[K]): void {
    const customEvent = new CustomEvent(event, { detail: body });
    window.dispatchEvent(customEvent);
  },

  on<K extends keyof EventMap>(event: K, listener: TypedEventListener<K>) {
    window.addEventListener(event, listener as (e: Event) => void);
  },

  off<K extends keyof EventMap>(event: K, listener: TypedEventListener<K>) {
    window.removeEventListener(event, listener as (e: Event) => void);
  },

  listen<K extends keyof EventMap>(event: K, listener: TypedEventListener<K>) {
    window.addEventListener(event, listener as (e: Event) => void);

    return function stopListening() {
      window.removeEventListener(event, listener as (e: Event) => void);
    };
  },
};

export type TypedEvent<K extends keyof EventMap> = CustomEvent<EventMap[K]>;

export type TypedEventListener<K extends keyof EventMap> = (
  event: TypedEvent<K>,
) => void;
